import { ChangeDetectionStrategy, Component, effect, inject, input, viewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SafeUrl } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { ZoomControlComponent } from 'src/app/shared/components/ui/zoom-control/zoom-control.component';
import { ZoomableDirective } from 'src/app/shared/directives/zoomable.directive';
import { ImageDialogComponent } from '../image-dialog/image-dialog.component';

@Component({
  selector: 'app-image-viewer',
  standalone: true,
  imports: [MatIconModule, MatButtonModule, MatTooltipModule, TranslateModule, ZoomControlComponent, ZoomableDirective],
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageViewerComponent {
  src = input<string | SafeUrl | null>(null);
  alt = input<string>('');
  borderRadius = input<string>('0');
  objectFit = input<'cover' | 'contain' | 'fill'>('cover');
  fillContainer = input<boolean>(false);
  enableZoom = input<boolean>(false);
  disableTouchMove = input<boolean>(false);

  private dialog = inject(MatDialog);
  zoomable = viewChild(ZoomableDirective);

  constructor() {
    effect(() => {
      // Reset zoom whenever src changes
      const _ = this.src();
      this.zoomable()?.resetZoom();
    });
  }

  openFullView(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    const imageSrc = this.src();
    if (!imageSrc) return;

    this.dialog.open(ImageDialogComponent, {
      data: {
        imageUrl: imageSrc,
        description: this.alt(),
      },
      panelClass: 'mermaid-dialog-panel',
      width: '95vw',
      height: '95vh',
      maxWidth: '95vw',
      maxHeight: '95vh',
    });
  }
}
